import { Controller } from 'stimulus'
import Rails from '@rails/ujs'

export default class extends Controller {

  static targets = ['layout', 'dropdown']

  connect() {
    this.toggle()
  }

  toggle(event) {
    let dropdown = null
    if (event) {
      dropdown = event.currentTarget
      for(let dropdown of this.dropdownTargets) {
        dropdown.value = event.currentTarget.value
      }
    } else {
      dropdown = this.dropdownTarget
    }
    if (event) {
      dropdown.form.requestSubmit()
    } else {
      for(let layout of this.layoutTargets) {
        if (layout.dataset.layout == dropdown.value) {
          layout.classList.remove('dn')
          Rails.fire(layout, 'rendered')
        } else {
          layout.classList.add('dn')
        }
      }
    }
  }
}
